<script>
import formatGender from "@utils/format-gender";
import formatDate from "@utils/format-date"
import formatServiceTime from "@utils/format-service-time";

export default {
  page() {
    return {
      title: `留言 | ${this.commentItem.id}`,
    }
  },
  components: {
    Layout: () => import('@layout/main'),
    CommentCarouselImage: () => import('./components/IndexJtails/CommentCarouselImage'),
  },
  props: {
    commentItem: {
      type: Object,
      required: true
    },
  },
  computed: {
    carouselList() {
      return (this.commentItem?.images || []).map(image => {
        return {
          src: image,
          thumb: image,
          caption: "",
        }
      });
    },
    questionList() {
      const optionValue = (index) => {
        const options = this.commentItem.questions.afterOrderOption;
        const value = options[index] && typeof options[index] === 'object'
          ? options[index].join(',')
          : options[index];

        return options[index]
          ? value
          : null;
      };

      const questionsMap = [
        {
          title: '正常',
          type: 'text',
        },
        {
          title: '皮膚病',
          type: 'text',
        },
        {
          title: '指甲流血',
          type: 'text',
        },
        {
          title: '剃傷',
          type: 'text',
        },
        {
          title: '跳蚤',
          type: 'option',
          value: optionValue(0)
        },
        {
          title: '壁蝨',
          type: 'option',
          value: optionValue(1)
        },
        {
          title: '耳炎',
          type: 'option',
          value: optionValue(2)
        },
        {
          title: '耳疥',
          type: 'option',
          value: optionValue(3)
        },
        {
          title: '眼睛',
          type: 'option',
          value: optionValue(4)
        }
      ];

      return questionsMap.filter(item => {
        const isIncludesAfterOder = this.commentItem.questions.afterOrder.includes(item.title);

        return isIncludesAfterOder && (item.type === 'text' || !!item.value);
      });
    },
  },
  methods: {
    formatDate,
    formatGender,
    formatServiceTime,
  }
}
</script>
<!-- section template -->
<template>
  <Layout :class="$style.viewComment">
    <BaseBanner
      :title="`${commentItem.fullName}${formatGender(commentItem.gender)}`"
      type="B"
      description="以下為您的寵物備註"
      class="text-center viewComment__banner"
    />
    <section :class="$style.sectionComment" class="section">
      <div class="container">
        <div class="sectionComment__detailBox">
          <div class="sectionComment__detailBoxInner text-center">
            <div class="sectionComment__date">
              {{ formatDate(commentItem.orderStartDate, 'MM/dd (EEE)') }}
            </div>
            <div class="sectionComment__time">
              {{ formatDate(commentItem.orderStartDate, 'HH:mm') }}
            </div>
            <div class="sectionComment__hour">
              (預計{{ formatServiceTime(commentItem.param.serviceTime) }})
            </div>
          </div>
          <div class="sectionComment__detailBoxInner">
            <div class="text-center mb-4">
              <div class="sectionComment__name">
                {{ commentItem.param.title }} - {{ commentItem.param.store.title }}
              </div>
              <div class="sectionComment__meta">
                {{ commentItem.pet.name }} - {{ commentItem.pet.categoryTitle }} | {{ commentItem.pet.sizeTitle }}
              </div>
            </div>
            <div class="sectionComment__no">
              訂單編號: #{{ commentItem.orderNo }}
            </div>
            <CommentCarouselImage
              v-if="!!commentItem.images && !!commentItem.images[0]"
              class="sectionComment__images"
              :carousel-list="carouselList"
            />
            <div :class="$style.contentList">
              <div
                v-if="!!commentItem.content"
                class="contentList__item"
              >
                <p class="sectionComment__content" v-text="commentItem.content"></p>
              </div>
              <div
                v-if="commentItem.questions && !!commentItem.questions.afterOrder[0]"
                class="contentList__item"
              >
                美容後問題:
                <ul>
                  <li
                    v-for="(questionItem, index) in questionList"
                    :key="index"
                  >
                    {{ questionItem.title }} <span v-if="questionItem.value">({{ questionItem.value }})</span>
                  </li>
                </ul>
              </div>
              <div
                v-if="commentItem.questions && !!commentItem.questions.handle[0]"
                class="contentList__item"
              >
                善後處理：
                <ul>
                  <li
                    v-for="(handle, index) in commentItem.questions.handle"
                    :key="`handleList-${index}`"
                  >
                    {{ handle }}
                  </li>
                </ul>
              </div>
            </div>
            <BasePre>questions: {{ commentItem.questions }}</BasePre>
          </div>
        </div>
      </div>
    </section>
    <BasePre>commentItem: {{ commentItem }}</BasePre>
  </Layout>
</template>
<!-- section style -->
<style lang="scss" module>
.viewComment {
  :global {
    .viewComment {
      &__banner {
        padding-bottom: 6rem;

        @include max-md {
          padding-bottom: 36px;
        }
      }
    }
  }
}

.sectionComment {
  position: relative;
  z-index: 1;
  padding-top: 0;

  :global {
    .sectionComment {
      &__detailBox {
        position: relative;
        margin-top: -4rem;
        background: #FFF;
        border-radius: 16px;
        box-shadow: 2px 8px 36px #1C2C5414;

        @include max-md {
          margin-top: 0;
          margin-right: -$container-gap;
          margin-left: -$container-gap;
          border-radius: 0;
        }

        &::before {
          position: absolute;
          top: -140px;
          right: 0;
          z-index: 1;
          width: 180px;
          height: 180px;
          content: "";
          background-image: url('~@assets/images/home/pattern-1.svg');
          background-position: center;
          background-size: cover;
          transform: translateX(50%);

          @include max-sm {
            display: none;
          }
        }
      }

      &__outlineBox {
        padding: 3rem 2.5rem 0;

        @include max-md {
          padding: 2rem 0 0;
        }
      }

      &__detailBoxInner {
        padding: 3.75rem 10.5rem;

        @include max-md {
          padding: 2rem $container-gap;
        }

        &:not(:last-child) {
          border-bottom: 1px solid $color-line;
        }

        &.isFull {
          padding: 3.75rem 2.5rem;

          @include max-md {
            padding: 2rem $container-gap;
          }

        }
      }

      &__date {
        display: inline-block;
        padding: 0.5rem 1rem;
        margin-bottom: 1.25rem;
        font-family: $font-number;
        font-weight: 600;
        border: 1px solid $color-gray-4;
        border-radius: 6px;
      }

      &__time {
        font-family: $font-number;
        font-size: 3rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-primary;
      }

      &__hour {
        font-size: 0.875rem;
        color: $color-gray-2;
      }

      &__no {
        padding: 1rem;
        margin-bottom: 2rem;
        font-size: 0.875rem;
        background: rgba($color-blue, 0.3);
        border: 1px solid $color-primary;
      }

      &__name {
        margin-bottom: 0.25rem;
        font-weight: 600;
      }

      &__meta {
        font-size: 0.875rem;
        color: $color-gray-2;
      }

      &__images {
        margin-bottom: 1.5rem;
      }

      &__content {
        line-height: 1.75;
        white-space: pre-wrap;
      }
    }
  }

  .container {
    @include max-md {
      padding: 0;
    }
  }
}

.contentList {
  :global {
    .contentList {
      &__item {
        &:not(:last-child) {
          margin-bottom: 1rem;
          border-bottom: 1px solid $color-line;
        }
      }
    }
  }
}
</style>
